import { render, staticRenderFns } from "./CateringOrderView.vue?vue&type=template&id=e129f800&"
import script from "./CateringOrderView.vue?vue&type=script&lang=js&"
export * from "./CateringOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports